export default "__VITE_ASSET__DlzIxaNp__"